import { ApiInstance } from '..'
import { GetTxHistoryParams, TxHistory } from './types'

export const getTxHistory = (params: GetTxHistoryParams) => {
  return ApiInstance.post<{ data: TxHistory[]; total: number }>('', { cmd: 'apid.get_history_list', para: params })
}
